import React, { useState } from 'react'
export const EnrollmentContext = React.createContext()
export const EnrollmentDispatch = React.createContext()

// Temporary custom hook
export const useEnrollmentStep1 = () => {
  const [isLoginUI, setIsLoginUI] = useState(false)

  const renderLoginUI = () => {
    setIsLoginUI(true)
  }

  const renderRegistrationUI = () => {
    setIsLoginUI(false)
  }

  return {
    isLoginUI,
    renderLoginUI,
    renderRegistrationUI
  }
}

const EnrollmentContextWrapper = ({ children, state, dispatch }) => {
  return (
    <EnrollmentDispatch.Provider value={dispatch}>
      <EnrollmentContext.Provider value={state}>{children}</EnrollmentContext.Provider>
    </EnrollmentDispatch.Provider>
  )
}
export default EnrollmentContextWrapper
